import Panel from './panel';

export default Panel;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/Panel/index.jsx